import { render, staticRenderFns } from "./ThanksEng.vue?vue&type=template&id=5cef7a8e&scoped=true"
import script from "./ThanksEng.vue?vue&type=script&lang=js"
export * from "./ThanksEng.vue?vue&type=script&lang=js"
import style0 from "./ThanksEng.vue?vue&type=style&index=0&id=5cef7a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef7a8e",
  null
  
)

export default component.exports